import axios from "axios";
import meetnetSiteStore from "@/store/meetnet/measurementSite";
import meetnetSensorStore from "@/store/meetnet/measurementSensor";
import { setInterceptors } from "@/services/interceptors";
setInterceptors();

const state = {
  meetnetJWT: "",
  meetnetAuthPayload: "",
  meetnetBaseURL: "",
  sinappsAppID: "",
};

const getters = {
  meetnetJWT(state) {
    return state.meetnetJWT;
  },
  meetnetAuthPayload(state) {
    return state.meetnetAuthPayload;
  },
  meetnetBaseURL(state) {
    return state.meetnetBaseURL;
  },
  meetnetAPIURL(state) {
    return `${state.meetnetBaseURL}/api`;
  },
  sinappsAppID(state) {
    return parseInt(state.sinappsAppID);
  },
};

const mutations = {
  setMeetnetJWT(state, token) {
    localStorage.setItem("meetnetJWT", token);
    state.meetnetJWT = token;
  },
  setMeetnetAuthPayload(state, payload) {
    localStorage.setItem("meetnetAuthPayload", JSON.stringify(payload));
    state.meetnetAuthPayload = payload;
  },
  setMeetnetBaseURL(state, baseURL) {
    localStorage.setItem("meetnetBaseURL", baseURL);
    state.meetnetBaseURL = baseURL;
  },
  setSinappsAppID(state, sinappsAppID) {
    state.sinappsAppID = parseInt(sinappsAppID);
  },
};

const actions = {
  authenticateMeetnet(context, baseURL) {
    let casJWT = localStorage.getItem("jwt");
    let url = `${baseURL}/api-token-auth`;

    context.commit("setMeetnetBaseURL", baseURL);
    console.log("auth callede", baseURL);

    return axios({
      method: "POST",
      withCredentials: true,
      headers: { Authorization: "jwt " + casJWT },
      url,
    });
  },

  fetchNetworkAndVariables(context, payload) {
    console.log("fetchMeasurementSites called");
    let axiosPromises = [];
    payload.measurementnetworks.forEach((oid) => {
      context.dispatch("fetchNetworkSiteVariables", oid);
      axiosPromises.push(context.dispatch("getMeasurementNetwork", oid));
    });

    axios.all(axiosPromises).then(
      axios.spread((...args) => {
        let measurementNetworks = [];
        for (let i = 0; i < args.length; i++) {
          // console.log("args[i].data", args[i].data);
          measurementNetworks.push(args[i].data);
        }
        context.commit("setMeasurementNetworks", {
          data: measurementNetworks,
          sinappsAppID: payload.sinappsAppID,
        });
      })
    );
  },

  setupMeetnet(context, payload) {
    context.commit("setMeetnetAuthPayload", payload);
    context.commit("setSinappsAppID", payload.sinappsAppID);
    console.log("setupMeetnet call sinapp id", payload.sinappsAppID);

    context
      .dispatch("authenticateMeetnet", payload.url)
      .then((response) => {
        context.commit("setMeetnetJWT", response.data.token);

        // set Measurement Network IDs
        context.commit("setMeasurementNetworkIDs", {
          data: payload.measurementnetworks,
          sinappsAppID: payload.sinappsAppID,
        });

        // fetch Networks and their Variables
        context.dispatch("fetchNetworkAndVariables", payload);
      })
      .catch((error) => {
        console.log("authenticateMeetnet error", error);
      });
  },

  setMeetnetJWT({ commit }, token) {
    commit("setMeetnetJWT", token);
  },
  setSinappsAppID({ commit }, sinappsAppID) {
    commit("setSinappsAppID", sinappsAppID);
  },
};

const modules = {
  meetnetSiteStore,
  meetnetSensorStore,
};

export default {
  state,
  getters,
  mutations,
  actions,
  modules,
};
